export default __webpack_public_path__ + "static/media/sea-coral.10267796b82d4ce2085fb4469acbc2da.jpg";